import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const UserIcon = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path id="UserIcon" d="M29.436,27.422c6.372,0 11.537,5.164 11.537,11.537l0,0.98c0,0.586 -0.476,1.061 -1.061,1.061l-31.824,0c-0.585,0 -1.061,-0.475 -1.061,-1.061l0,-0.98c0,-6.373 5.165,-11.537 11.537,-11.537l10.872,0Zm8.977,11.032c-0.262,-4.722 -4.192,-8.486 -8.977,-8.486l-10.872,0c-4.79,0 -8.715,3.764 -8.977,8.486l28.826,0Zm-14.481,-13.154c5.053,0 9.153,-4.098 9.153,-9.151c0,-5.055 -4.1,-9.149 -9.153,-9.149c-5.053,0 -9.152,4.099 -9.152,9.153c0,5.053 4.099,9.147 9.152,9.147Zm0,-15.754c3.641,0 6.606,2.961 6.606,6.607c0,3.645 -2.961,6.606 -6.606,6.606c-3.645,0 -6.606,-2.961 -6.606,-6.606c0,-3.646 2.965,-6.607 6.606,-6.607Z" fill={fill} />
    </svg>
  );
};

UserIcon.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

UserIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
